'use client'

import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Badge } from '@cocoonspace/ui/components/badge'
import { Card, cardVariants } from '@cocoonspace/ui/components/card'
import { useLingui } from '@lingui/react/macro'
import Image from 'next/image'
// import { TwicImg } from '@twicpics/components/react'
import { LocalizedLink as Link } from '~/components/localized-link'

import type { Post } from '~/domains/blog/list-posts'

export const PostCard = ({
	post,
	domain,
}: {
	post: Post
	domain: 'use-cases' | 'blog'
}) => {
	const { t } = useLingui()

	return (
		<Link
			className={cardVariants({
				className: 'flex flex-col no-underline',
			})}
			href={`/${domain}/${post.slug}`}
			key={post.id}
		>
			{!!post.cover?.url && (
				<Card className='relative m-0 h-48 w-full overflow-hidden p-0 sm:h-72 md:h-96 [&_img]:!max-w-full'>
					<Image
						className='m-0 size-full object-cover object-center'
						src={post.cover.url}
						alt={post.cover.name ?? ''}
						fill
						priority
						sizes='100vw'
					/>
				</Card>
			)}
			{/* {!!post.twicPicsSrc && (
				<TwicImg
					alt={post.title}
					className='h-72 rounded-t'
					ratio='none'
					src={post.twicPicsSrc}
				/>
			)} */}

			<header className='flex flex-col justify-between gap-1 p-4'>
				<h2 className='!m-0 p-0 text-xl leading-none font-semibold'>
					{post.title}
				</h2>

				<div className='flex flex-wrap gap-2'>
					<div className='text-muted-foreground mr-auto flex items-center gap-1 text-sm'>
						<span>{t`Publié le :`}</span>
						{dateTimeUtils(post.publishedAt).format('DD/MM/YYYY')}
					</div>

					{post.categories.map(({ name }) => (
						<Badge
							className='capitalize'
							key={name}
							size='sm'
							variant='secondary'
						>
							# {name}
						</Badge>
					))}
				</div>
			</header>
		</Link>
	)
}
